import { useMemo } from 'react'
import { CommonBarChart } from './CommonBarChart'
import type { RobotServiceCountItem } from '@/types/api'

interface Props {
  data: RobotServiceCountItem[]
}

export function InteractionTimeChart({ data }: Props) {
  const formattedData = useMemo(() => {
    const list = Array.isArray(data) ? data : []
    return list
      .map((item: any) => {
        return {
          name: item.robotName || item.unitName,
          time: item.time ?? item.totalInteractionTime ?? 0,
        }
      })
      .sort((a, b) => b.time - a.time)
  }, [data])

  return (
    <CommonBarChart
      title="THỜI GIAN TƯƠNG TÁC THEO ROBOT"
      data={formattedData}
      xKey="name"
      yKey="time"
      theme="purple"
      legendLabel="Thời gian tương tác (giờ)"
      activeType="badge"
    />
  )
}
